module.exports = __webpack_public_path__ + "static/media/Header2.cf1909fe.jpg";